/**
 * @module components\TxnHistory
 */
import Vue from 'vue';
import Component from 'vue-class-component';
import { required, numeric, minLength, maxLength, email } from "vuelidate/lib/validators";
import LoaderMobile from '@/services/loaderMobile';
import sToast from '@/services/sToast';
import core from '@/services/core';
import store from '@/store';
import * as XLSX from "xlsx";
import utilities from "@/utilities";
import _ from "lodash";
import { customPattern } from "@/validations/customPattern";


@Component({
    validations: {
        userInfo: {
            name: {
                required,
                customPattern: customPattern('^[a-zA-Z\\s]*$')
            },
            mob: {
                required,
                numeric,
                minLength: minLength(10),
                maxLength: maxLength(10)

            },
            email: {
                required,
                email
            }
        }
    }
})
export default class EditUser extends Vue {
    dialog = false;
    dialogSuccess = false;
    action = "";
    userInfo: any = {
        id: "",
        name: "",
        mob: "",
        email: "",
        sts: "",
        stsCode: "",
        action: ""
    };

    get loggedInUser() {
        return store.getters.sessLoginDataGet;
    }

    created() {
        this.userInfo = store.getters.manageUserGet.updateUser;
    }

    navigateManageUser() {
        store.dispatch("updateManageUserAc", null);
        this.$router.push({ name: "manageUser" });
    }

    editUser() {
        this.$v.$touch();
        if (this.$v.$invalid) {
            return false;
        }
        let request = {
            token: this.loggedInUser.sessionId,
            clientId: this.loggedInUser.clientId,
            id: this.userInfo.id,
            name: this.userInfo.name,
            mob: this.userInfo.mob,
            email: this.userInfo.email,
            action: this.userInfo.action
        };
        core
            .post({
                data: request,
                url: 'user/modify',
                method: 'post'
            })
            .then(response => {
                this.dialogSuccess = true;
                console.log("User Response", response);
                console.log("User Req", this.userInfo);
            })
            .catch(error => {

            });

    }

    performAction(action: string) {
        this.userInfo.action = action;
        this.action = action;
        this.editUser();
    }
}
